import { combineReducers } from "redux";
import { urlImportReducer } from "./reducers/urlImportReducer";

const documentSection = combineReducers({
  urlImportReducer,
});

export { documentSection };
